import React, {JSX} from 'react';

import {Dropdown} from '@pb/kit-component-dropdown-v2';
import {Item} from '@pb/kit-component-group';
import {Input} from '@pb/kit-component-input-v2';

type Props = {
    inputName: string,
    inputValue: string,
    inputPlaceholder?: string,
    onToggle: () => void,
    shown: boolean,
    validationHighLight: boolean,
    children: JSX.Element,
};

export const FormDropdown = ({
    inputName,
    inputValue,
    inputPlaceholder,
    onToggle,
    shown,
    validationHighLight,
    children,
}: Props) => {

    const color = !validationHighLight || inputValue ? 'DEFAULT' : 'ERROR';
    const onFocus = () => {
        if (shown) {
            return;
        }

        onToggle();
    };

    return (
        <Dropdown
            anchor={({anchorRef, getAnchorProps}) => (
                <Item style={{width: '100%'}}>
                    <Input
                        ref={anchorRef}
                        {...getAnchorProps()}
                        className="ellipsis"
                        name={inputName}
                        value={inputValue}
                        placeholder={inputPlaceholder}
                        color={color}
                        onFocus={onFocus}
                    />
                </Item>
            )}
            clickEnabled={false}
            hideOnBodyLeave={false}
            maxHeight={0}
            floatingFocusManagerProps={{returnFocus: false}}
            shown={shown}
            setShown={onToggle}>
            {children}
        </Dropdown>
    );
};
